<template>
  <div class="modal-overlay web-auth-modal" v-if="visible" @click.self="close">
    <div class="modal-box modal-register-box">
      <div class="auth-box">
        <div class="logo">
          <div class="logo-icon"><img :src="logoImg" alt="logo" class="logo-icon-img" /></div>
          <h1>注册开户</h1>
          <p class="sub">完成以下步骤即可开始交易</p>
        </div>
        <div class="step-bar">
          <div class="step-dot" :class="{ active: step === 0, done: step > 0 }"></div>
          <div class="step-dot" :class="{ active: step === 1, done: step > 1 }"></div>
          <div class="step-dot" :class="{ active: step === 2, done: step > 2 }"></div>
          <div class="step-dot" :class="{ active: step === 3, done: step > 3 }"></div>
        </div>

        <!-- Step 0: Email + Code + Invite -->
        <div v-if="step === 0">
          <div class="step-title">邮箱注册</div>
          <div class="step-desc">请输入邮箱并完成验证</div>
          <div class="form-group"><label>邮箱</label><div class="input-wrap"><input type="email" v-model="form.email" placeholder="请输入邮箱" @input="clearError"></div></div>
          <div v-if="errors.email" class="field-error">{{ errors.email }}</div>
          <div class="form-group"><label>验证码</label><div class="input-wrap code-row"><input type="text" v-model="form.code" placeholder="6位邮箱验证码" maxlength="6" @input="clearError"><button type="button" class="btn-code" @click="sendCode" :disabled="codeCooldown > 0">{{ codeCooldown > 0 ? codeCooldown + 's' : '获取验证码' }}</button></div></div>
          <div v-if="errors.code" class="field-error">{{ errors.code }}</div>
          <div class="form-group"><label>邀请码 <span class="label-opt">（选填）</span></label><div class="input-wrap"><input type="text" v-model="form.inviteCode" placeholder="填写邀请人 UID" maxlength="12"></div></div>
          <div v-if="errors.general" class="form-error">{{ errors.general }}</div>
          <button class="btn-primary" @click="nextStep0" :disabled="loading">{{ loading ? '处理中...' : '下一步' }}</button>
        </div>

        <!-- Step 1: Login Password -->
        <div v-else-if="step === 1">
          <div class="step-title">设置登录密码</div>
          <div class="step-desc">密码 6-20 位，建议包含字母和数字</div>
          <div class="form-group"><label>登录密码</label><div class="input-wrap"><input type="password" v-model="form.password" placeholder="请输入密码" maxlength="20" @input="clearError"></div></div>
          <div v-if="errors.password" class="field-error">{{ errors.password }}</div>
          <div class="form-group"><label>确认密码</label><div class="input-wrap"><input type="password" v-model="form.confirmPwd" placeholder="再次输入密码" @input="clearError"></div></div>
          <div v-if="errors.confirmPwd" class="field-error">{{ errors.confirmPwd }}</div>
          <div v-if="errors.general" class="form-error">{{ errors.general }}</div>
          <button class="btn-primary" @click="nextStep1" :disabled="loading">{{ loading ? '处理中...' : '下一步' }}</button>
        </div>

        <!-- Step 2: Trade Password -->
        <div v-else-if="step === 2">
          <div class="step-title">设置交易密码</div>
          <div class="step-desc">用于下单、出金等敏感操作，6 位数字</div>
          <div class="form-group"><label>交易密码</label><div class="input-wrap"><input type="password" v-model="form.tradePwd" placeholder="6位数字" maxlength="6" @input="clearError"></div></div>
          <div v-if="errors.tradePwd" class="field-error">{{ errors.tradePwd }}</div>
          <div class="form-group"><label>确认交易密码</label><div class="input-wrap"><input type="password" v-model="form.confirmTradePwd" placeholder="再次输入" maxlength="6" @input="clearError"></div></div>
          <div v-if="errors.confirmTradePwd" class="field-error">{{ errors.confirmTradePwd }}</div>
          <div v-if="errors.general" class="form-error">{{ errors.general }}</div>
          <button class="btn-primary" @click="nextStep2" :disabled="loading">{{ loading ? '处理中...' : '下一步' }}</button>
        </div>

        <!-- Step 3: Success -->
        <div v-else-if="step === 3">
          <div class="success-icon">✓</div>
          <div class="step-title" style="text-align:center">开户成功</div>
          <div class="step-desc" style="text-align:center">
            <template v-if="registerResult.uid">UID：<strong>{{ registerResult.uid }}</strong><br></template>
            账户已开通，现在可以开始交易了
          </div>
          <button class="btn-primary" @click="finishRegister">开始交易</button>
        </div>

        <div class="auth-link">已有账号？<a href="javascript:void(0)" @click="$emit('switch-login')">返回登录</a></div>
      </div>
      <div style="text-align:center;margin-top:12px"><a href="javascript:void(0)" @click="close" style="color:#999;font-size:13px;text-decoration:none">关闭</a></div>
    </div>
  </div>
</template>

<script>
import { showToast } from '@/utils/common'
import { isValidEmail } from '@/utils/validate'

export default {
  name: 'RegisterModal',
  props: { visible: Boolean },
  data() {
    return {
      logoImg: require('@/assets/logo/logo-icon.png'),
      step: 0,
      form: { email: '', code: '', password: '', confirmPwd: '', tradePwd: '', confirmTradePwd: '', inviteCode: '' },
      errors: { email: '', code: '', password: '', confirmPwd: '', tradePwd: '', confirmTradePwd: '', general: '' },
      codeCooldown: 0,
      loading: false,
      registerResult: {}
    }
  },
  methods: {
    close() {
      this.$emit('close')
    },
    clearError() {
      this.errors = { email: '', code: '', password: '', confirmPwd: '', tradePwd: '', confirmTradePwd: '', general: '' }
    },
    async sendCode() {
      if (!this.form.email) { this.errors.email = '请输入邮箱'; return }
      if (!isValidEmail(this.form.email)) { this.errors.email = '邮箱格式不正确'; return }
      this.clearError()
      // 立即开始倒计时，给用户即时反馈
      this.codeCooldown = 60
      const timer = setInterval(() => { this.codeCooldown--; if (this.codeCooldown <= 0) clearInterval(timer) }, 1000)
      try {
        await this.$store.dispatch('user/sendCode', { email: this.form.email, scene: 'register' })
        showToast('验证码已发送，请查收邮箱')
      } catch (e) {
        // 发送失败时停止倒计时
        clearInterval(timer)
        this.codeCooldown = 0
        this.errors.general = e.message || '发送验证码失败'
      }
    },
    async nextStep0() {
      this.clearError()
      // 校验邮箱
      if (!this.form.email) { this.errors.email = '请输入邮箱'; return }
      if (!isValidEmail(this.form.email)) { this.errors.email = '邮箱格式不正确'; return }
      if (!this.form.code || this.form.code.length !== 6) { this.errors.code = '请输入6位验证码'; return }
      this.loading = true
      try {
        await this.$store.dispatch('user/registerStep1Action', {
          email: this.form.email,
          code: this.form.code
        })
        this.step = 1
      } catch (e) {
        this.errors.general = e.message || '验证失败'
      }
      this.loading = false
    },
    async nextStep1() {
      this.clearError()
      if (!this.form.password || this.form.password.length < 6) { this.errors.password = '密码不能少于6位'; return }
      if (this.form.password.length > 20) { this.errors.password = '密码不能超过20位'; return }
      if (this.form.password !== this.form.confirmPwd) { this.errors.confirmPwd = '两次密码不一致'; return }
      this.loading = true
      try {
        await this.$store.dispatch('user/registerStep2Action', {
          email: this.form.email,
          password: this.form.password
        })
        this.step = 2
      } catch (e) {
        this.errors.general = e.message || '设置密码失败'
      }
      this.loading = false
    },
    async nextStep2() {
      this.clearError()
      if (!this.form.tradePwd || this.form.tradePwd.length !== 6) { this.errors.tradePwd = '交易密码为6位数字'; return }
      if (!/^\d{6}$/.test(this.form.tradePwd)) { this.errors.tradePwd = '交易密码只能为数字'; return }
      if (this.form.tradePwd !== this.form.confirmTradePwd) { this.errors.confirmTradePwd = '两次交易密码不一致'; return }
      this.loading = true
      try {
        await this.$store.dispatch('user/registerStep3Action', {
          email: this.form.email,
          tradePwd: this.form.tradePwd
        })
        // Step 4: 完成注册（含邀请码）
        const res = await this.$store.dispatch('user/registerStep4Action', {
          email: this.form.email,
          inviteCode: this.form.inviteCode || ''
        })
        this.registerResult = res.data || {}
        // 注册成功，清除 localStorage 中已使用的邀请码
        localStorage.removeItem('ftx_invite_code')
        this.step = 3
      } catch (e) {
        this.errors.general = e.message || '注册失败'
      }
      this.loading = false
    },
    finishRegister() {
      this.$emit('switch-login')
      this.close()
    }
  },
  watch: {
    visible(v) {
      if (v) {
        this.step = 0
        // 从 localStorage 读取邀请码（由路由守卫在用户点击邀请链接时保存）
        const savedInviteCode = localStorage.getItem('ftx_invite_code') || ''
        this.form = { email: '', code: '', password: '', confirmPwd: '', tradePwd: '', confirmTradePwd: '', inviteCode: savedInviteCode }
        this.errors = { email: '', code: '', password: '', confirmPwd: '', tradePwd: '', confirmTradePwd: '', general: '' }
        this.registerResult = {}
        this.codeCooldown = 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.web-auth-modal .modal-box { width: 420px; padding: 32px 40px; }
.modal-register-box { max-height: 90vh; overflow-y: auto; }
.auth-box { width: 100%; }
.auth-box .logo { text-align: center; margin-bottom: 32px; }
.auth-box .logo-icon {
  width: 56px; height: 56px; background: transparent; border-radius: 14px;
  margin: 0 auto 12px; display: flex; align-items: center; justify-content: center;
}
.auth-box .logo-icon-img {
  width: 56px; height: 56px;
}
.auth-box h1 { font-size: 22px; text-align: center; }
.auth-box .sub { text-align: center; color: var(--text-secondary); font-size: 13px; margin-top: 4px; }
.step-bar { display: flex; justify-content: center; gap: 8px; margin-bottom: 24px; }
.step-dot { width: 8px; height: 8px; border-radius: 50%; background: #ddd; transition: all .3s; }
.step-dot.active { width: 24px; border-radius: 4px; background: var(--red); }
.step-dot.done { background: var(--green); }
.step-title { font-size: 16px; font-weight: 600; margin-bottom: 4px; }
.step-desc { font-size: 13px; color: var(--text-secondary); margin-bottom: 20px; }
.label-opt { font-size: 12px; color: var(--text-muted); font-weight: 400; }
.code-row { display: flex; gap: 8px; input { flex: 1; } }
.btn-code {
  white-space: nowrap; padding: 0 12px; background: transparent; color: var(--red);
  border: none; font-size: 13px; cursor: pointer; font-family: inherit;
  &:disabled { color: var(--text-muted); cursor: not-allowed; }
}
.field-error { font-size: 12px; color: var(--red); margin-top: 4px; margin-bottom: 8px; }
.form-error { text-align: center; color: var(--red); font-size: 13px; margin-top: 12px; }
.success-icon {
  width: 72px; height: 72px; border-radius: 50%; background: var(--green);
  margin: 0 auto 16px; display: flex; align-items: center; justify-content: center;
  color: #fff; font-size: 36px; font-weight: 700;
}
.btn-primary {
  width: 100%; padding: 12px; background: var(--red); color: #fff;
  border: none; border-radius: 6px; font-size: 15px; font-weight: 600;
  cursor: pointer; font-family: inherit;
  &:hover { opacity: .92; } &:disabled { opacity: .5; cursor: not-allowed; }
}
.auth-link { text-align: center; margin-top: 16px; font-size: 14px; color: var(--text-secondary); a { color: var(--red); text-decoration: none; font-weight: 600; } }
</style>
